module.exports = __webpack_public_path__ + "media/470083__sheyvan__music-orchestral-victory-fanfare.74c7c515.mp4";